<template>
  <div class="report">
    <img
      src="/dashboard/pdf.svg"
    >
    <a
      class="download-report"
      @click="downloadReport"
    >
      {{ report.file.fileName }}
    </a>
  </div>
</template>

<script>
export default {
    props: {
        report: {
            type: Object,
            default: () => ({
                type: {
                    id: null,
                    label: null,
                },
                file: {
                    fileName: null,
                    format: null,
                    id: null,
                    size: 0,
                },
            }),
        },
    },

    methods: {
        async downloadReport() {
            const { data } = await this.$rq.downloadFile(this.report.file.id);

            this.$utils.saveFileOnDisk(data, this.report.file.fileName);
        },
    },
};
</script>


  <style lang="scss" scoped>
  .report {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      width: 100%;
      padding: 20px 20px;

      &:not(:first-child) {
          border-top: 1px solid #DEDEDE;
      }

      .download-report {
          width: 100%;
          margin-left: 14px;
          color: #EF4135;
          font-size: 16px;
          font-weight: 400;
          text-transform: capitalize;
          text-decoration: underline;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;

      }
  }
  </style>
